export const AICG_SHOW_INIT = 'AICG_SHOW_INIT'; // AIGC入口
export const AICG_SHOW_DILOG = 'AICG_SHOW_DILOG'; // AIGC主窗口

export const AICG_GET_REPLYS = 'AICG_GET_REPLYS'; // AIGC获得当前回复
export const AICG_GET_REPLYS_SUCCESS = 'AICG_GET_REPLYS_SUCCESS'; // AIGC获得当前回复

export const AICG_GET_QUESTION = 'AICG_GET_QUESTION'; // AIGC获得当前回复的相关问题
export const AICG_GET_QUESTION_SUCCESS = 'AICG_GET_QUESTION_SUCCESS'; // AIGC获得当前回复的相关问题

export const AICG_ADD_ZAN_DAO = 'AICG_ADD_ZAN_DAO'; // 是否点赞或者倒
export const AICG_REPLYS_ADD_REPLY = 'AICG_REPLYS_ADD_REPLY'; // replyList 添加数据
export const AICG_CLEAR_LIST = 'AICG_CLEAR_LIST'; // 清除聊天对话List
export const AICG_ADD_DOWNLOAD = 'AICG_ADD_DOWNLOAD'; // 添加下载任务
export const AICG_REPLY_COMMAND_END = 'AICG_REPLY_COMMAND_END'; // 处理回复中的指令完成
export const AICG_REPLY_WRITING_END = 'AICG_REPLY_WRITING_END'; // 是否为打字效果结束
export const AICG_REPLY_WRITING_STOP = 'AICG_REPLY_WRITING_STOP'; // 处理回复中的指令完成
export const AICG_REPLY_IS_BUSING = 'AICG_REPLY_IS_BUSING'; // 处理中忙碌中不支持操作
export const AICG_SHOW_MESSAGE = 'AICG_SHOW_MESSAGE'; // 控制消息弹窗是否显示
export const AICG_SAVE_PREV_CONTEXT = 'AICG_SAVE_PREV_CONTEXT'; // 控制点击左右切换后context是切换后的
